/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as CustomerActions from '@app/customers/store/customers.actions';
import { CustomersState, initialState } from '@app/customers/store/customers.state';

export function customersReducer(state = initialState, action: CustomerActions.CustomersActions): CustomersState {
  switch (action.type) {
    case CustomerActions.LOAD_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.customers,
        actionPending: false
      };
    case CustomerActions.LOAD_CUSTOMERS:
      return {
        ...state,
        actionPending: true
      };
    case CustomerActions.LOAD_CUSTOMERS_PARTIAL:
      return {
        ...state,
        actionPending: true
      };
    case CustomerActions.LOAD_CUSTOMERS_PARTIAL_SUCCESS:
      return  {
        ...state,
        customersPartial: action.customers,
        actionPending: false
      };
    default:
      return state;
  }
}
